var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.29102,
    cy: 1.87695,
    r: 1.5,
    fill: "#255056"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.29102,
    cy: 8.87695,
    r: 1.5,
    fill: "#255056"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.29102,
    cy: 15.877,
    r: 1.5,
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDots);
export default __webpack_public_path__ + "static/media/verticalDots.4a1840b8328d2647d67bba7bd6a06a13.svg";
export { ForwardRef as ReactComponent };